import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import styles from './LandingNav.module.css';

// `registerPath` sets where the "Sign up free" CTA goes. Defaults to the public /register
// flow; the private founding page passes "/founding" to keep visitors in that flow.
//
// `searchSlot` is an optional node rendered just before the account actions. Only the Help
// Center passes one (its search, once the hero copy has scrolled away); every other page
// leaves it null and renders exactly as before.
//
// `fixed` takes the header out of the page's scroll flow (see `.navFixed` in the stylesheet
// for why the Help Center needs that). A page that passes it must reserve the nav's height
// itself, since the header no longer occupies any.
export default function LandingNav({
  registerPath = '/register',
  searchSlot = null,
  fixed = false,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  // Official logo at frontend/public/logo.png; fall back to the lettermark if missing.
  const [logoOk, setLogoOk] = useState(true);

  function goHome() {
    if (location.pathname === '/') {
      document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
    }
  }

  return (
    <header className={`${styles.nav} ${fixed ? styles.navFixed : ''}`}>
      <div className={styles.inner}>
        <button className={styles.logo} onClick={goHome} aria-label="RepBuddy home">
          {logoOk ? (
            <img
              className={styles.logoImg}
              src={`${process.env.PUBLIC_URL}/logo.png`}
              alt="RepBuddy"
              onError={() => setLogoOk(false)}
            />
          ) : (
            <span className={styles.logoMark}>R</span>
          )}
          <span className={styles.logoName}>RepBuddy</span>
        </button>

        <nav className={styles.links} aria-label="Sections">
          <button className={styles.link} onClick={() => navigate('/product')}>Product</button>
          <button className={styles.link} onClick={() => navigate('/pricing')}>Pricing</button>
          <button className={styles.link} onClick={() => navigate('/compare')}>Compare</button>
          <button className={styles.link} onClick={() => navigate('/about')}>About us</button>
        </nav>

        {searchSlot && <div className={styles.searchSlot}>{searchSlot}</div>}

        <div className={styles.actions}>
          {user ? (
            <button className={styles.primary} onClick={() => navigate('/app')}>Go to app</button>
          ) : (
            <>
              <button className={styles.login} onClick={() => navigate('/login')}>Log in</button>
              <button
                className={styles.primary}
                onClick={() => navigate(registerPath)}
              >
                Sign up free
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
